import styled from 'styled-components'
import { LogoIcon } from '../../assets/icons/logo'
import { FileIcon } from '../../assets/icons/file'
import {
  Container,
  DialogMUI,
} from '../../pages/recommendations/Recommendations'
import HowToInterpretCharts from '../modals/HowToInterpretCharts'
import { Modal } from '@mui/material'
import {useEffect, useState} from 'react'
import AboutBiomarker from '../modals/AboutBiomarker'
import { BrowserRouter, Link } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom'
import { getHashObj, getUrl } from './../getSubjectId'
import LinkHover from "../LinkHover";
import {
  Background,
  LeftSide,
  RightSide,
  Button,
  Body
} from './Header.styled'
import http from '../http/http'
import { Arrow, ArrowCircle, ArrowDropdown } from '../../assets/icons/arrow'
import ContainerContent from '../ContainerContent'
import { useTranslation } from 'react-i18next';
import { PromBanner, PromQuestionnaire } from '../prom';
import { usePromStatus } from '../prom/usePromStatus';
import { usePromRateLimit } from '../prom/usePromRateLimit';


export const Header = () => {
  const [isModalOpen, setIsOpenModal] = useState(false)
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false)
  const [promOpen, setPromOpen] = useState(false)
  const langOptions = [
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' },
  ]
  const { t, i18n } = useTranslation();

  const location = useLocation()
  const navigate = useNavigate()

  const { status: promStatus } = usePromStatus()
  const rateLimit = usePromRateLimit()
  const showPromBanner = promStatus?.due === true && !rateLimit.isRateLimited()

  const handleCloseModal = () => setIsOpenModal(false)
  const handleModalOpen = () => setIsOpenModal(true)

  const handleLogout = async () => {
    try {
      await http.post('/api/users/auth/logout', {});
    } catch (e) {}
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');
    navigate('/login');
  }

  useEffect(()=>{
  }, [location.pathname])

  const type = /form|home/gi.test(location.pathname) ? 'FORM' : 'RESULTS'
  const isHealthActive = /theme/gi.test(location.pathname)
  const isLoggedIn = Boolean(localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken'));
  const menuItemStyle: React.CSSProperties = { padding: '12px 20px', cursor: 'pointer', lineHeight: '20px' };
  const menuItemDisabledStyle: React.CSSProperties = { ...menuItemStyle, color: '#aaa', cursor: 'not-allowed'};
  const menuItemDangerStyle: React.CSSProperties = { ...menuItemStyle, color: '#e96863' };

  const handleAccountMenuToggle = () => {
    setIsAccountMenuOpen((v) => {
      if (!v) setIsLangMenuOpen(false)
      return !v
    })
  }
  const handleLangMenuToggle = () => {
    setIsLangMenuOpen((v) => {
      if (!v) setIsAccountMenuOpen(false)
      return !v
    })
  }
  return (
    <Background data-header data-url={location.pathname}>
      <DialogMUI
        scroll='body'
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
        onClose={handleCloseModal}
        open={isModalOpen}
      >
        <HowToInterpretCharts onClose={handleCloseModal} />
      </DialogMUI>
      <PromBanner visible={showPromBanner} onClick={() => { setPromOpen(true); }} phase={promStatus?.phase} />
      <PromQuestionnaire open={promOpen} onClose={() => setPromOpen(false)} />
      <div>
        <ContainerContent background='transparent'>
          <Body data-animch data-header-content>
            <LeftSide data-fade data-left-side>
              <Link to='https://smrtlife.ch' style={{marginTop: '10px'}}>
                <LogoIcon />
              </Link>
              {/* Language Switcher */}
              {/* {type === 'RESULTS' && <div className={'linksWrap'}  data-animch='1'>
                <LinkHover to={getUrl('biomarkers')} className={'linkHover ' + (!isHealthActive ? "activeLinkHover" : '')}>Biomarkers</LinkHover>
                <LinkHover to={getUrl('summary')} className={'linkHover ' + (isHealthActive ? "activeLinkHover" : '')}>Health Report</LinkHover>
              </div>} */}
            </LeftSide>
            <RightSide  style={{ position: 'relative', zIndex: 100 }}>
              {type === 'FORM' && <div className={'linksWrap'}  data-animch='1'>
                <></>
              </div>}

              {/* {type === 'RESULTS' && <>
                <span>
                  <Button  className={'mobileHidden btn headerBtn'} onClick={handleModalOpen}>How to interpret charts?</Button>
                </span>
                <span>
                    <Button className={'mobileHidden btn headerBtn'}
                        onClick={() => {
                          window.print()
                        }}
                    >
                      <FileIcon style={{marginRight: '5px'}}/>
                      Print page
                    </Button>
                  </span>
              </>} */}
              {isLoggedIn ? (
                <>
                  <span style={{ position: 'relative', marginLeft: 16 }}>
                    <Button
                      className={'btn headerBtn'}
                      onClick={handleLangMenuToggle}
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {i18n.language === 'en' ? 'EN' : 'DE'}
                      <span style={{ display: 'flex', alignItems: 'center', marginLeft: 4, width: 16, height: 16 }}>
                        <ArrowDropdown />
                      </span>
                    </Button>
                    {isLangMenuOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 'calc(100% + 8px)',
                          background: '#fff',
                          border: '1px solid #ededed',
                          borderRadius: 8,
                          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                          minWidth: 80,
                          zIndex: 100,
                          padding: '8px 0'
                        }}
                      >
                        {langOptions.map((lang, idx) => (
                          <div
                            key={lang.code}
                            style={{
                              padding: '12px 20px',
                              cursor: 'pointer',
                              lineHeight: '20px',
                              fontWeight: 600,
                              color: i18n.language === lang.code ? '#3baab0' : '#222',
                              background: i18n.language === lang.code ? '#e6f7f8' : undefined,
                            }}
                            onClick={() => {
                              setIsLangMenuOpen(false)
                              i18n.changeLanguage(lang.code)
                              localStorage.setItem('i18nextLng', lang.code)
                            }}
                          >
                            {lang.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </span>
                  <span style={{ position: 'relative' }}>
                    <Button
                      className={'btn headerBtn'}
                      onClick={handleAccountMenuToggle}
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {t('account')}
                      <span style={{ display: 'flex', alignItems: 'center', marginLeft: 4, width: 16, height: 16 }}>
                        <ArrowDropdown />
                      </span>
                    </Button>
                    {isAccountMenuOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          right: 0,
                          top: 'calc(100% + 8px)',
                          background: '#fff',
                          border: '1px solid #ededed',
                          borderRadius: 8,
                          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                          minWidth: 220,
                          zIndex: 9999,
                          padding: '8px 0'
                        }}
                      >
                        <div
                          style={{
                            ...menuItemStyle,
                            background: hoveredIndex === 0 ? '#f0f0f0' : undefined,
                          }}
                          onClick={() => { setIsAccountMenuOpen(false); navigate('/profile'); }}
                          onMouseEnter={() => setHoveredIndex(0)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >{t('profile')}</div>
                        <div
                          style={{
                            ...menuItemStyle,
                            background: hoveredIndex === 1 ? '#f0f0f0' : undefined,
                          }}
                          onClick={() => { setIsAccountMenuOpen(false); navigate('/orders'); }}
                          onMouseEnter={() => setHoveredIndex(1)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >{t('orders')}</div>
                        <div
                          style={{
                            ...menuItemStyle,
                            background: hoveredIndex === 2 ? '#f0f0f0' : undefined,
                          }}
                          onClick={() => { setIsAccountMenuOpen(false); navigate('/my-reports'); }}
                          onMouseEnter={() => setHoveredIndex(2)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >{t('myReports')}</div>
                        <div
                          style={menuItemDisabledStyle}
                        >{t('healthHistory')}</div>
                        <div style={{ borderTop: '1px solid #ededed', margin: '8px 0' }} />
                        <div
                          style={{
                            ...menuItemDangerStyle,
                            background: hoveredIndex === 3 ? '#f0f0f0' : undefined,
                          }}
                          onClick={() => { setIsAccountMenuOpen(false); handleLogout(); }}
                          onMouseEnter={() => setHoveredIndex(3)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >{t('logout')}</div>
                      </div>
                    )}
                  </span>
                </>
              ) : (
                <>
                  <span style={{ position: 'relative', marginRight: 16 }}>
                    <Button
                      className={'btn headerBtn'}
                      onClick={handleLangMenuToggle}
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {i18n.language === 'en' ? 'EN' : 'DE'}
                      <span style={{ display: 'flex', alignItems: 'center', marginLeft: 4, width: 16, height: 16 }}>
                        <ArrowDropdown />
                      </span>
                    </Button>
                    {isLangMenuOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 'calc(100% + 8px)',
                          background: '#fff',
                          border: '1px solid #ededed',
                          borderRadius: 8,
                          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                          minWidth: 80,
                          zIndex: 100,
                          padding: '8px 0'
                        }}
                      >
                        {langOptions.map((lang, idx) => (
                          <div
                            key={lang.code}
                            style={{
                              padding: '12px 20px',
                              cursor: 'pointer',
                              lineHeight: '20px',
                              fontWeight: 600,
                              color: i18n.language === lang.code ? '#3baab0' : '#222',
                              background: i18n.language === lang.code ? '#e6f7f8' : undefined,
                            }}
                            onClick={() => {
                              setIsLangMenuOpen(false)
                              i18n.changeLanguage(lang.code)
                              localStorage.setItem('i18nextLng', lang.code)
                            }}
                          >
                            {lang.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </span>
                  <span>
                    <Link to="/login">
                      <Button className={'mobileHidden btn headerBtn'}>{t('login')}</Button>
                    </Link>
                  </span>
                  <span>
                    <Link to="/register">
                      <Button className={'mobileHidden btn headerBtn'}>{t('register')}</Button>
                    </Link>
                  </span>
                </>
              )}
            </RightSide>
          </Body>
        </ContainerContent>
      </div>
      {isLangMenuOpen && (
        <div
          onClick={() => setIsLangMenuOpen(false)}
          style={{ position: 'fixed', left: 0, right: 0, top: 0, bottom: 0, zIndex: 99 }}
        />
      )}
      {isAccountMenuOpen && (
        <div
          onClick={() => setIsAccountMenuOpen(false)}
          style={{ position: 'fixed', left: 0, right: 0, top: 0, bottom: 0, zIndex: 99 }}
        />
      )}
    </Background>
  )
}

export default Header
